import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const dsRepricingDrawerData = signal({})
export const dsRepricingDrawerErrors = signal({})
export const dsRepricingListData = signal([])
export const dsRepricingStatusFilter = signal(['Enabled'])
export const dsRepricingIsLoading = signal(false)
export const dsRepricingIsSubmitting = signal(false)
export const dsRepricingOriginalData = signal(null)

export const isDsRepricingDrawerOpen = computed(() => dsRepricingDrawerData.value && !isEmpty(dsRepricingDrawerData.value))

export const clearDsRepricingSignals = () => batch(() => {
	dsRepricingDrawerData.value = {}
	dsRepricingDrawerErrors.value = {}
	dsRepricingOriginalData.value = null
})
